module.exports.url = "https://cocokids.co/api/v1";
// module.exports.url = "http://localhost:8000/api/v1";
// module.exports.url = "https://coco.staging.codecart.in/api/v1";